// components/TasteSection.js
"use client";
import React from "react";
import "./FooterHero.scss";
import Image from "next/image";

const FooterHero = ({
  heading,
  description,
  buttonText,
  buttonLink,
  image,
}) => {
  return (
    <div className="taste-section mx-auto" style={{ maxWidth: "800px" }}>
      <div className="row px-5 px-md-4 w-100">
        <div className="col-12 mt-5 px-0 px-md-5 d-flex align-items-center w-100">
          <div className="taste-content w-100" style={{ maxWidth: "800px" }}>
            <h3 className="line-heading">
              {heading}
              <span className="dash-left"></span>
              <span className="dash-right"></span>
            </h3>
            <p className="mt-3 mb-5">{description}</p>
          </div>
        </div>
        <div className="col-12  order-3 order-md-4 px-0 px-md-5 ">
          <Image
            className="p-0 p-md-2 img-fluid w-100"
            src={image}
            width={680}
            height={450}
            alt="event"
          />
        </div>
        <div className="col-12 mb-4 mt-3 order-3 order-md-4 px-0 px-md-5 d-flex align-items-center justify-content-center">
          <div className="taste-content">
            {buttonText && (
              <button
                className="line-button"
                onClick={() => (window.location.href = buttonLink)}
              >
                {buttonText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterHero;
